import type { DataAction } from '../../../types/dataAction.type';
import type { PageState } from '../types/ReducerTypes';

export const UPDATE_QUICK_LINKS = 'UPDATE_QUICK_LINKS' as const;
export const updateQuickLinks = (quickLinks: PageState) => ({
  data: { quickLinks },
  type: UPDATE_QUICK_LINKS,
});
export type UpdateQuickLinksAction = DataAction<typeof UPDATE_QUICK_LINKS, { quickLinks: PageState }>;
